<template>
  <div class="form_error" v-if="validation.$error">
    <small class="d-block invalid-feedback">{{ errorMessage() }}</small>
  </div>
</template>

<script lang="ts">
import { Validation } from '@vuelidate/core';
import { defineComponent, PropType } from 'vue'
import { VALIDATOR_KEYS } from '@/config/i18n'

export default defineComponent({
  name: 'ControlErrorMessage',
  props: {
    i18nLabel: {
      type: String,
      required: false,
      default:""
    },
    validation: {
      type: Object as PropType<Validation>,
      required: true
    }
  },
  methods: {
    findFirstValidator() {
      for (const key of VALIDATOR_KEYS) {
        const found = this.validation.$errors.find(error => error.$validator === key)
        if (found) {
          return found
        }
      }
      return undefined
    },
    errorMessage() {
      const validator = this.findFirstValidator()
      const key = validator?.$validator || 'fallback'
      const params = validator?.$params || {}
      return this.$t('validators.' + key, [this.$t(this.i18nLabel)].concat(Object.values(params)))
    }
  }
});
</script>

